<template>
  <div id="app" style="padding: .5rem 16px;text-align: left;" class="vue-dpn">
    <van-pull-refresh v-model="isLoading"  @refresh="onRefresh">




      <div style="">

      <form action="/">
        <van-search
            v-model="value"
            placeholder="请输入合同号或者订单号"
            show-action
            shape="round"
            @search="onSearch"
        >
          <!-- <div slot="action" @click="onSearch"></div> -->
          <template #action>
    <div @click="onSearch">搜索</div>
  </template>
        </van-search>
      </form>

    </div>


      <div style="">
        <div class="pending-list" style="padding-bottom: 2rem;">

          <!-- <div v-if="currentListLoading">
            <van-skeleton title :row="3" />
          </div> -->


          <div v-if="!currentListLoading && false">
            <div
              class="pending-list-item"
              v-for="(item, index) in currentList"
              v-if="currentList.length && false"
              
            >
              <div @click="goDetail(item)">
                <div class="cus-row cus-row-v-m">
                  <div class="cus-row-col-6">
                    <span class="ffm f-c-212120 s-32-45">
                      {{ item.real_name }} </span
                    ><span class="ffr f-c-b5b5b5 s-24-33">
                      线路： {{ item.contract_name }}</span
                    >
                  </div>
                  <div class="cus-row-col-6 t-al-r">
                    <span class="status-btn">
                      <!-- {{ item.remark ? "审核失败" : "审核中" }} -->
                        {{ (item.status == 1)?"草稿":"" }}
                        {{ (item.status != 1)?item.contract_state_txt:"" }}
                      <span
                        style="
                          position: absolute;
                          top: 50%;
                          -webkit-transform: translateY(-50%);
                          transform: translateY(-50%);
                          right: 0.1rem;
                        "
                        ><van-icon name="play"
                      /></span>
                    </span>
                  </div>
                </div>

                <div style="margin-top: 0.2rem" class="in-bl-line">
                  <span
                    class="ffr f-c-757575 s-28-40"
                    style="font-weight: bold"
                    >{{ item.contract_main_name }}</span
                  >
                </div>

                <div class="barrie-line-sa" style="margin-top: 0.4rem"></div>
              </div>

              <div class="cus-row cus-row-v-m" style="margin-top: 0.16rem">
                <div class="cus-row-col-8" v-if="item.contract_numbe">
                  <span class="ffr f-c-b5b5b5 s-24-33" @click="goDetail(item)"
                    >合同号：{{ item.contract_numbe }}</span
                  >
                  <span
                    class="copy-text ffr f-c-b5b5b5 s-24-33"
                    @click="doCopy(item.contract_numbe)"
                    >复制</span
                  >
                </div>

                <div class="cus-row-col-8" v-if="!item.contract_numbe">
                  <span class="ffr f-c-b5b5b5 s-24-33" @click="goDetail(item)"
                    >订单号：{{ item.bill_no }}</span
                  >
                  <span
                    class="copy-text ffr f-c-b5b5b5 s-24-33"
                    @click="doCopy(item.bill_no)"
                    >复制</span
                  >
                </div>
                <div class="cus-row-col-4 t-al-r">
                  <span class="ffr f-c-b5b5b5 s-24-33">{{ item.valid_date }}</span>
                </div>
              </div>


              <div
                style="
                  margin-top: 0.3rem;
                  margin-left: -0.3rem;
                  margin-right: -0.3rem;
                  border-top: 1px solid #e4e4e4;
                  margin-bottom: -0.32rem;
                "
                
              >
                <div
                  class="cus-row cus-row-v-m opr-line"
                  style="color: #1889f8"
                >
                  <div
                    class="cus-row-col-6 t-al-c"
                    @click="copyLoan(item)"
                  >
                                                   <div class="in-bl-v-m">
                                                      <img src="../assets/images/copy.png" style="width: 16px;"/>
                                                  </div>
                    <span class="opr-span">复制</span>
                  </div>

                  <div class="cus-row-col-6 t-al-c" @click="goDetail(item)">
                    <div class="in-bl-v-m">
                                                      <img src="../assets/images/eyes.png" style="width: 20px;"/>
                                                  </div>
                    <span class="opr-span" style="color:#000000 !important;">详情</span>
                  </div>
                  <!--                            <div class="cus-row-col-4 t-al-c" @click="goDetail(item)">-->
                  <!--                                <div class="in-bl-v-m">-->
                  <!--                                    <van-icon name="eye-o" />-->
                  <!--                                </div>-->
                  <!--                                <span class="opr-span">查看</span>-->
                  <!--                            </div>-->
                </div>
              </div>

              <div
                style="
                  margin-top: 0.3rem;
                  margin-left: -0.3rem;
                  margin-right: -0.3rem;
                  border-top: 1px solid #e4e4e4;
                  margin-bottom: -0.32rem;
                "
                v-if="canEdit(item)"
              >
                <div
                  class="cus-row cus-row-v-m opr-line"
                  style="color: #1889f8"
                >
                  <div
                    class="cus-row-col-6 t-al-c"
                    @click="cancelLoan(item)"
                    :style="canCancel(item)"
                  >
                    <!--                                <div class="in-bl-v-m">-->
                    <!--                                    <van-icon name="delete"/>-->
                    <!--                                </div>-->
                    <span class="opr-span">取消</span>
                  </div>
                  <div class="cus-row-col-6 t-al-c" @click="editLoan(item)">
                    <!--                                <div class="in-bl-v-m" :style="canEdit(item)">-->
                    <!--                                    <van-icon name="edit" />-->
                    <!--                                </div>-->
                    <span class="opr-span">修改</span>
                  </div>
                  <!--                            <div class="cus-row-col-4 t-al-c" @click="goDetail(item)">-->
                  <!--                                <div class="in-bl-v-m">-->
                  <!--                                    <van-icon name="eye-o" />-->
                  <!--                                </div>-->
                  <!--                                <span class="opr-span">查看</span>-->
                  <!--                            </div>-->
                </div>
              </div>
            </div>

            <div
              v-if="!currentList.length"
              class="t-al-c"
              style="margin-top: 0.96rem"
            >
              <img
                src="~@/assets/images/no_order.png"
                style="width: 2rem; display: inline-block"
              />
            </div>

            <div
              v-if="!currentList.length"
              class="t-al-c s-26-37 ffr f-c-b5b5b5"
              style="margin-top: 0.56rem"
            >
              暂无数据
            </div>
          </div>

          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <!-- <van-cell v-for="item in list" :key="item" :title="item">

            </van-cell> -->

              <div>
                <div
              class="pending-list-item"
              v-for="(item, index) in list"
            >
              <div @click="goDetail(item)">
                <div class="cus-row cus-row-v-m">
                  <div class="cus-row-col-6">
                    <span class="ffm f-c-212120 s-32-45">
                      {{ item.real_name }} </span
                    ><span class="ffr f-c-b5b5b5 s-24-33">
                      线路： {{ item.contract_name }}</span
                    >
                  </div>
                  <div class="cus-row-col-6 t-al-r">
                    <span class="status-btn">
                      <!-- {{ item.remark ? "审核失败" : "审核中" }} -->
                        {{ (item.status == 1)?"草稿":"" }}
                        {{ (item.status != 1)?item.contract_state_txt:"" }}
                      <span
                        style="
                          position: absolute;
                          top: 50%;
                          -webkit-transform: translateY(-50%);
                          transform: translateY(-50%);
                          right: 0.1rem;
                        "
                        ><van-icon name="play"
                      /></span>
                    </span>
                  </div>
                </div>

                <div style="margin-top: 0.2rem" class="in-bl-line">
                  <span
                    class="ffr f-c-757575 s-28-40"
                    style="font-weight: bold"
                    >{{ item.contract_main_name }}</span
                  >
                </div>

                <div class="barrie-line-sa" style="margin-top: 0.4rem"></div>
              </div>

              <div class="cus-row cus-row-v-m" style="margin-top: 0.16rem">
                <div class="cus-row-col-8" v-if="item.contract_numbe">
                  <span class="ffr f-c-b5b5b5 s-24-33" @click="goDetail(item)"
                    >合同号：{{ item.contract_numbe }}</span
                  >
                  <span
                    class="copy-text ffr f-c-b5b5b5 s-24-33"
                    @click="doCopy(item.contract_numbe)"
                    >复制</span
                  >
                </div>

                <div class="cus-row-col-8" v-if="!item.contract_numbe">
                  <span class="ffr f-c-b5b5b5 s-24-33" @click="goDetail(item)"
                    >订单号：{{ item.bill_no }}</span
                  >
                  <span
                    class="copy-text ffr f-c-b5b5b5 s-24-33"
                    @click="doCopy(item.bill_no)"
                    >复制</span
                  >
                </div>
                <div class="cus-row-col-4 t-al-r">
                  <span class="ffr f-c-b5b5b5 s-24-33">{{ item.valid_date }}</span>
                </div>
              </div>


              <div
                style="
                  margin-top: 0.3rem;
                  margin-left: -0.3rem;
                  margin-right: -0.3rem;
                  border-top: 1px solid #e4e4e4;
                  margin-bottom: -0.32rem;
                "
                
              >
                <div
                  class="cus-row cus-row-v-m opr-line"
                  style="color: #1889f8"
                >
                  <div
                    class="cus-row-col-6 t-al-c"
                    @click="copyLoan(item)"
                  >
                                                   <div class="in-bl-v-m">
                                                      <img src="../assets/images/copy.png" style="width: 16px;"/>
                                                  </div>
                    <span class="opr-span">复制</span>
                  </div>

                  <div class="cus-row-col-6 t-al-c" @click="goDetail(item)">
                    <div class="in-bl-v-m">
                                                      <img src="../assets/images/eyes.png" style="width: 20px;"/>
                                                  </div>
                    <span class="opr-span" style="color:#000000 !important;">详情</span>
                  </div>
                  <!--                            <div class="cus-row-col-4 t-al-c" @click="goDetail(item)">-->
                  <!--                                <div class="in-bl-v-m">-->
                  <!--                                    <van-icon name="eye-o" />-->
                  <!--                                </div>-->
                  <!--                                <span class="opr-span">查看</span>-->
                  <!--                            </div>-->
                </div>
              </div>

              <div
                style="
                  margin-top: 0.3rem;
                  margin-left: -0.3rem;
                  margin-right: -0.3rem;
                  border-top: 1px solid #e4e4e4;
                  margin-bottom: -0.32rem;
                "
                v-if="canEdit(item)"
              >
                <div
                  class="cus-row cus-row-v-m opr-line"
                  style="color: #1889f8"
                >
                  <div
                    class="cus-row-col-6 t-al-c"
                    @click="cancelLoan(item)"
                    :style="canCancel(item)"
                  >
                    <!--                                <div class="in-bl-v-m">-->
                    <!--                                    <van-icon name="delete"/>-->
                    <!--                                </div>-->
                    <span class="opr-span">取消</span>
                  </div>
                  <div class="cus-row-col-6 t-al-c" @click="editLoan(item)">
                    <!--                                <div class="in-bl-v-m" :style="canEdit(item)">-->
                    <!--                                    <van-icon name="edit" />-->
                    <!--                                </div>-->
                    <span class="opr-span">修改</span>
                  </div>
                  <!--                            <div class="cus-row-col-4 t-al-c" @click="goDetail(item)">-->
                  <!--                                <div class="in-bl-v-m">-->
                  <!--                                    <van-icon name="eye-o" />-->
                  <!--                                </div>-->
                  <!--                                <span class="opr-span">查看</span>-->
                  <!--                            </div>-->
                </div>
              </div>
            </div>
              </div>


          </van-list>



          <!--                <div class="t-al-c in-bl-line" style="margin-top: .48rem;">-->
          <!--                    <div style="padding: 0.14rem 0.28rem;background-color: rgba(255, 255, 255, 0.75);border-radius: 0.3rem;border: solid 0.02rem #e4e4e4;color:#1889f8;display: inline-block;" @click="showMeiqia">-->
          <!--                        <van-icon name="service-o" size=".33rem" :style="{'vertical-align': 'middle'}"/>-->
          <!--                        <span class="f-c-1889f8 s-24-33 ffm in-bl" style="vertical-align: middle;margin-left: 0.1rem;">在线客服</span>-->
          <!--                    </div>-->
          <!--                </div>-->

        </div>

      </div>
    </van-pull-refresh>


    <tar-bar @showqr="showqr"></tar-bar>
    <van-popup
        v-model="show"
        position="bottom"
        closeable
        close-icon-position="top-right"
        :style="{ height: 'auto' }"
        :close-on-click-overlay="false"
        ref="pop"
    >
      <div style="background-color: #ffffff;padding: 0.72rem .48rem .48rem .48rem">
        <div class="wx-text">微信扫一扫，申请分期</div>

        <div style="margin-top: 0.16rem;font-family: PingFangSC-Regular;font-size: 0.28rem;font-weight: normal;color: #222222;">
          请向客户出示此二维码，长按图片/截屏保存到相册
        </div>


        <div style="background-color: #1889f9;padding: 0.14rem 0.16rem 0.18rem 0.16rem;border-radius: 0.16rem;margin-top: 0.48rem">
          <div style="background-color: #ffffff;border-radius: 0.08rem;padding-bottom: 90%;position: relative">
            <div class="ab-t-t-x-y" style="width: 70%;font-size: 0;">
              <img :src="qrcodePath" style="width: 100%;"/>
            </div>
          </div>

          <div style="margin-top: .28rem;" class="in-bl-line">
            <div style="width: 0.58rem;height: 0.58rem;background-color: #ffffff;border-radius: 0.72rem;border: solid 0.04rem #fffefe;display: inline-block;vertical-align: middle;">
              <van-image
                  round
                  width="0.58rem"
                  height="0.58rem"
              />
            </div>

            <div class="in-bl" style="margin-left: .28rem;font-family: PingFangSC-Medium;font-size: 0.32rem;color: #ffffff;vertical-align: middle;">
              {{edu_name}} <span style="font-family: PingFangSC-Light;">客户分期二维码</span>
            </div>
          </div>

        </div>

      </div>
    </van-popup>


    <!-- start of 分配代理 -->
    <div
      style="
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 9;
      "
      class="t-al-c"
      v-if="owner_delegate_show"
    >
      <div
        style="
          position: absolute;
          background: rgba(26, 26, 26, 0.85);
          top: 0;
          right: 0;
          left: 0;
          bottom: 0;
        "
      ></div>
      <div
        class="ab-t-t-x-y"
        style="
          width: 300px;
          min-height: 100px;
          background: #ffffff;
          border-radius: 12px;
          overflow: hidden;
        "
      >
        <div
          role="dialog"
          aria-labelledby="标题"
          class=""
          style="z-index: 2003"
        >
          <div class="van-dialog__header" style="font-size: 14px;">选择复制方式</div>
          <div class="van-dialog__content">
            <div style="margin: 20px 0; padding: 0 20px; text-align: left;">
              <!-- <div style="font-size: 14px; color: #333; margin-bottom: 12px;">请选择复制方式</div> -->
              <van-radio-group v-model="copy_type" direction="vertical" class="copy-radio-group" style="margin-top: 8px;">
                <van-radio :name="1" style="font-size: 20px; line-height: 30px;">复制游客</van-radio>
                <van-radio :name="2" style="font-size: 20px; line-height: 30px;">不复制游客</van-radio>
              </van-radio-group>
            </div>
          </div>
          <div
            class="van-hairline--top van-dialog__footer van-dialog__footer--buttons"
          >
            <button
              class="van-button van-button--default van-button--large van-dialog__cancel"
              @click="cancelSetDelegate"
            >
              <span class="van-button__text">取消</span></button
            ><button
              class="van-button van-button--default van-button--large van-dialog__confirm van-hairline--left"
              @click="confirmSetDelegate"
            >
              <span class="van-button__text">确认</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- start of 分配代理 -->

  </div>
</template>


<script>
import common from '@/assets/js/common'
import { listJobs, copyJob } from '@/assets/js/api'
import TarBar from '../components/TarBar'
import {Dialog, Toast} from 'vant'
import _ from "underscore"
import moment from "moment"

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data: function(){
    return {
      periodArr:[3,6,9,12,24],
      period:'',
      price:'',
      class_name:'',
      pending_list:[],
      show:false,
      qrcodePath: common.dynamicHost() + '/entry_qrcode.png',
      userInfo:{},
      edu_name:{},
      edu_phone:{},
      pending_total_amount:0,
      amount_all:0,
      count_all:0,
      count_current_month:0,
      isLoading:false,
      pageNo: 0,
      value: '',

      option1:[
        { text: '全部状态', value: 0 },
        { text: '待审核', value: 1 },
        { text: '已生效', value: 2 }
      ],
      option2:[
        { text: '全部时间', value: 0 },
        { text: '今天', value: 1 },
        { text: '本月', value: 2 },
        { text: '今年', value: 3 }
      ],
      value1: 0,
      value2: 1,
      filterFixed: false,
      currentListLoading: true,
      user:{},
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      pageSize: 0,
      serach_key: "",
      owner_delegate_show: false,
      copy_type: null,
      current_copy_item: null
    }
  },
  components:{
    TarBar
  },
  methods:{

    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.refreshing = false;
      }
      // setTimeout(() => {
      // if (this.refreshing) {
      //   this.list = [];
      //   this.refreshing = false;
      // }

      // for (let i = 0; i < 10; i++) {
      //   this.list.push(this.list.length + 1);
      // }
      // this.loading = false;

      // if (this.list.length >= 40) {
      //   this.finished = true;
      // }
      // }, 1000);

      //TODO 加载数据
      listJobs({ pageNo: this.pageNo, pageSize: 12, keyword: this.serach_key }).then((res) => {
        if (res.errcode == 200) {
          if (!res.result.data.length) {
            this.finished = true
            this.loading = false
            return
          }
          for (let i = 0; i < res.result.data.length; i++) {
            let item = res.result.data[i]
            let bingo = false
            for (let j = 0; j < this.list.length; j++) {
              if (item.id == this.list[j].id) {
                bingo = true
                break
              }
            }
            if (!bingo) {
              this.list.push(item)
            }
          }
          this.pageNo = this.pageNo + 1
          this.loading = false
        }
      })



    },
    onRefresh() {
      // 清空列表数据
      this.refreshing = true
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.pageNo = 1
      this.onLoad();
    },

    copyLoan(item){
      console.log("复制合同")
      console.log(item)

      if( this.$common.isTestMode() ){
        this.current_copy_item = item
        this.copy_type = null
        this.owner_delegate_show = true
        return
      }


      Dialog.confirm({
        title: "确认要复制当前合同吗?",
      })
        .then(() => {
          // common.setSaAuth("");
          // common.setSaAuthWithRefresh("");
          // location.href = "sa_login";

          copyJob(item.id).then((res) => {
          if (res.errcode == 0) {
            this.goDetail({ id: res.data })
          } else {
            common.mAlert(this, res.errmsg)
          }
        })


        })
        .catch(() => {});
    },

    cancelSetDelegate(){
      this.owner_delegate_show = false
      this.current_copy_item = null
    },

    confirmSetDelegate(){
      if( !this.copy_type ){
        common.mAlert(this, "请选择复制方式")
        return
      }

      const item = this.current_copy_item
      this.owner_delegate_show = false

      copyJob(item.id).then((res) => {
          if (res.errcode == 0) {
            this.goDetail({ id: res.data })
          } else {
            common.mAlert(this, res.errmsg)
          }
        })
    },

    onSearch()
    {
      this.serach_key = this.value
      this.onRefresh()
    },
    showMeiqia()
    {
      this.onRefresh()
    },
    // onRefresh() {
    //   this.isLoading = false
    //   location.reload()
    // },
    doCopy: function (text) {
      let _self = this;
      this.$copyText(text).then(function (e) {
        common.mAlert(_self, '复制成功')
      }, function (e) {
        common.mAlert(_self, '复制失败')
      })
    },
    add()
    {
      location.href = 'sa_fill'
    },
    setPeriod(period)
    {
      this.period = period;
      // console.log(period);
      //要用上选择器了
      var objs = document.querySelectorAll('.term-item-active');
      for(var i =0 ,j = objs.length; i < j; i++)
      {
        objs[i].classList.remove('term-item-active');
      }
      var classList = document.querySelector('div[data-period="'+period+'"]').classList.add('term-item-active');
      console.log(classList);

    },
    nextStep(){


      //验证
      if (!this.class_name) {
        // this.$layer.msg('请输入课程名称')
        common.mAlert(this,'请输入课程名称');
        return;
      }

      if (!this.price) {
        common.mAlert(this,'请输入课程金额');
        return;
      }

      if (!this.period) {
        common.mAlert(this,'请选择课程期数');
        return;
      }


      common.authRequest({
        url: common.dynamicHost() + '/user/save-fill',
        page: this,
        type: 'get',
        data: {class_name:this.class_name,period:this.period,price:this.price},
        indicator:true,
        success:function(res)
        {
          if( res.status )
          {
            location.href = 'info';
          }
        },
        error:function () {
        }
      })
    },
    initPage()
    {
    },
    loginOut()
    {
      Dialog.confirm({
        title:'确认退出登录?'
      }).then(() => {
        common.setSaAuth('');
        common.setSaAuthWithRefresh('')
        location.href = 'sa_login';
      }).catch(() => {
      });
    },
    showqr(value)
    {
      this.show = true;
    },
    goDetail(item)
    {
      this.$router.push({ path: "new_invoice?id=" + item.id });
    },
    goFill()
    {
      location.href = 'sa_fill'
    },
    goFinish()
    {
      location.href = 'sa_done_list'
    },
    cancelLoan(item)
    {
      let stageArr = ['101', '201', '301']
      if( stageArr.indexOf(item.stage) === -1 )
      {
        return '';
      }
      this.goDetail(item)
    },
    editLoan(item)
    {
      let stageArr = ['101', '201', '301']
      if( stageArr.indexOf(item.stage) === -1 )
      {
        return '';
      }

      this.goDetail(item)
    },
    canCancel(item)
    {
      let stageArr = ['101', '201', '301']
      if( stageArr.indexOf(item.stage) !== -1 )
      {
        return true;
      }
      return false;
    },
    canEdit(item)
    {
      let stageArr = ['101', '201', '301']
      if( stageArr.indexOf(item.stage) !== -1 )
      {
        return true;
      }
      return false;
    },
    getLast1Month() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;//0-11表示1-12月
      let day = now.getDate();
      let dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + '-' + month + '-' + day;

      if (parseInt(month) == 1) {//如果是1月份，则取上一年的10月份
        dateObj.last = (parseInt(year) - 1) + '-12-' + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 1, 0).getDate();//开始时间所在月的总天数
      if (preSize < parseInt(day)) {
        // 开始时间所在月的总天数<本月总天数，比如当前是5月30日，在2月中没有30，则取下个月的第一天(3月1日)为开始时间
        let resultMonth = parseInt(month) < 10 ? ('0' + parseInt(month)) : (parseInt(month));
        dateObj.last = year + '-' + resultMonth + '-01';
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + '-0' + (parseInt(month) - 1) + '-' + day;
        return dateObj;
      } else {
        dateObj.last = year + '-' + (parseInt(month) - 1) + '-' + day;
        return dateObj;
      }

    },
    getLastWeek() {
      return {now: moment().format('YYYY-MM-DD'), last: moment().
        subtract('days', 6).format('YYYY-MM-DD')}
    },
    getLast3Month() {
      let now = new Date();
      let year = now.getFullYear();
      let month = now.getMonth() + 1;//0-11表示1-12月
      let day = now.getDate();
      let dateObj = {};
      if (parseInt(month) < 10) {
        month = "0" + month;
      }
      if (parseInt(day) < 10) {
        day = "0" + day;
      }

      dateObj.now = year + '-' + month + '-' + day;

      if (parseInt(month) == 1) {//如果是1月份，则取上一年的10月份
        dateObj.last = (parseInt(year) - 1) + '-10-' + day;
        return dateObj;
      }
      if (parseInt(month) == 2) {//如果是2月份，则取上一年的11月份
        dateObj.last = (parseInt(year) - 1) + '-11-' + day;
        return dateObj;
      }
      if (parseInt(month) == 3) {//如果是3月份，则取上一年的12月份
        dateObj.last = (parseInt(year) - 1) + '-12-' + day;
        return dateObj;
      }

      var preSize = new Date(year, parseInt(month) - 3, 0).getDate();//开始时间所在月的总天数
      if (preSize < parseInt(day)) {
        // 开始时间所在月的总天数<本月总天数，比如当前是5月30日，在2月中没有30，则取下个月的第一天(3月1日)为开始时间
        let resultMonth = parseInt(month) - 2 < 10 ? ('0' + parseInt(month) - 2) : (parseInt(month) - 2);
        dateObj.last = year + '-' + resultMonth + '-01';
        return dateObj;
      }

      if (parseInt(month) <= 10) {
        dateObj.last = year + '-0' + (parseInt(month) - 3) + '-' + day;
        return dateObj;
      } else {
        dateObj.last = year + '-' + (parseInt(month) - 3) + '-' + day;
        return dateObj;
      }

    }
  },
  created:function()
  {

    // common.setTitle('APA PPF')
  },
  computed:{
    btn_lock:function()
    {
      return true;
    },
    pending_list_count()
    {
      if( !this.pending_list )
      {
        return 0;
      }

      return this.pending_list.length;
    },
    currentList() {


      let keyword = this.value
      let target_arr = []
      for(let i=0, j=this.pending_list.length; i < j; i++)
      {
        let record = JSON.stringify(this.pending_list[i])
        console.log('关键字')
        console.log(record)
        if( record.indexOf(keyword) !== -1 )
        {
          target_arr.push(this.pending_list[i])
        }
      }

      return target_arr


      //状态过滤, 待完成1 ['101', '201', '301', '401', '402', '403', '501', '601']，已通过2 ['602', '701']， 已结束3 ['801']
      // _.where(this.pending_list, )
      // let targetList = []
      // if ( this.value1 == 1 ) {
      //   for (let i = 0, j = this.pending_list.length; i < j; i++) {
      //     let stageArr = [0]
      //     if (stageArr.indexOf(this.pending_list[i].status) !== -1) {
      //       targetList.push(this.pending_list[i])
      //     }
      //   }
      // } else if (this.value1 == 1)
      // {
      //   for (let i = 0, j = this.pending_list.length; i < j; i++) {
      //     let stageArr = [0]
      //     if (stageArr.indexOf(this.pending_list[i].stage) !== -1) {
      //       targetList.push(this.pending_list[i])
      //     }
      //   }
      // } else
      // {
      //   targetList = this.pending_list
      // }
      //
      // console.log('过滤前的值')
      // console.log(targetList)
      //
      //
      // //按照日期筛选
      // let targetList2 = []
      // if( this.value2 == 1 )
      // {
      //   //今日
      //   // for (let i = 0, j = targetList.length; i < j; i++) {
      //   //   let today_date = moment().format('YYYY-MM-DD')
      //   //   if ( targetList[i].date == today_date ) {
      //   //     targetList2.push(targetList[i])
      //   //   }
      //   // }
      //
      //   targetList2 = targetList
      //
      // } else if( this.value2 == 2 )
      // {
      //   //近一月
      //   let monthRange = this.getLastWeek()
      //   console.log(monthRange)
      //
      //   for (let i = 0, j = targetList.length; i < j; i++) {
      //
      //     if( targetList[i].date <= monthRange.now && targetList[i].date >= monthRange.last )
      //     {
      //       targetList2.push(targetList[i])
      //     }
      //
      //     // let today_date = moment().format('YYYY-MM-DD')
      //     // if ( targetList[i].date == today_date ) {
      //     //     targetList2.push(targetList[i])
      //     // }
      //   }
      // } else if( this.value2== 3 )
      // {
      //   //近三月
      //
      //   let monthRange = this.getLast1Month()
      //   console.log(monthRange)
      //
      //   for (let i = 0, j = targetList.length; i < j; i++) {
      //
      //     if( targetList[i].date <= monthRange.now && targetList[i].date >= monthRange.last )
      //     {
      //       targetList2.push(targetList[i])
      //     }
      //
      //     // let today_date = moment().format('YYYY-MM-DD')
      //     // if ( targetList[i].date == today_date ) {
      //     //     targetList2.push(targetList[i])
      //     // }
      //   }
      // } else
      // {
      //   targetList2 = targetList
      // }
      //
      // console.log('过滤后的值')
      // console.log(targetList2)
      //
      // return targetList2


      //时间过滤，今日，近一月，进三月


    }
  },
  mounted(){

    if( !common.getAuth() )
    {
      this.$router.push({ path: '/auth'})
      return
    }


    //移除vue-dpn
    common.removeDpnClass()
    this.initPage();
  }
}
</script>


<style scoped>

html,body{background-color: #ffffff !important;}


.filter_content{
  margin-left: -0.4rem  !important;
  margin-right: -0.4rem !important;
}

.filter-fixed
{
  position: fixed; top: 0; left: 0; right: 0;z-index: 99;border-bottom: 1px solid #e4e4e4;    box-shadow: 0 0 0.43rem 0 rgba(0, 0, 0, 0.06);
}

.opr-span
{
  color: #212121;;
  display: inline-block;
  vertical-align: middle;
  margin-left: .15rem;
  font-size: 0.24rem;
  line-height: .8rem;
}

.copy-text
{
  border: 1px solid #e4e4e4;
  border-radius: .33rem;
  padding: .02rem .1rem;
  margin-left: .04rem;
}

#app{
  -webkit-user-select:none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select:none;/*禁用页面内容选中和复制操作*/
  -webkit-touch-callout:none;/*禁用长按页面时的弹出菜单(iOS下有效)*/
  -webkit-tap-highlight-color:rgba(0,0,0,0);/*去掉点击链接和文本框对象时默认的灰色半透明覆盖层(iOS)或者虚框(Android)*/
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}

.in-bl{display: inline-block;}
.copy-radio-group >>> .van-radio {
  margin: 12px 0 !important;
  line-height: 22px !important;
  font-size: 14px !important;
}

.copy-radio-group >>> .van-radio__label {
  font-size: 14px !important;
  margin-left: 6px !important;
}

.copy-radio-group >>> .van-radio__icon {
  font-size: 14px !important;
}

.term-item
{
  background: #FFFFFF;
  border: 0.0325rem solid #CCCCCC;
  border-radius: .125rem;
  line-height: 1.25rem;
  width: 3rem !important;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: .5rem;
  color: #333333;
  display: inline-block;
  margin-right: 0.25rem;
}

.term-item-active
{
  border: 0.0325rem solid #FCE701;
  background-color: #FCE701 ;
}

.cheese_footer
{
  font-family: PingFangSC-Regular;
  font-size: 0.3125rem;
  color: #B2B2B2;
  text-align: center;
  line-height: 0.4375rem;
}

.fix_footer{
  position: absolute;
  left:50%;
  bottom: 2.5rem;
  text-align: center;
  z-index: 99;

}

.bottom_footer{
  margin-bottom: .5rem;
  margin-top: .5rem;
}

.new-btn
{
  line-height: 1rem;
  padding: 0 1rem;
  border-radius: 1rem;
  background-color: #1989FA;
  color: #ffffff;
  font-size: .4rem;
  transform: translateX(-50%);
}

.pending-list{
  margin-bottom: 2rem;
}

.pending-list-item
{
  margin-top: .32rem;
  padding: .32rem .30rem;
  background-color: #ffffff;
  /*box-shadow: 0.03rem 0.05rem 0.43rem 0.02rem*/
  /*rgba(0, 0, 0, 0.06);*/
  border-radius: 0.16rem;
  border: 1px solid #e4e4e4;
}

.status-btn{
  background-color: #f5f5f5;
  border-radius: 0.24rem;
  padding: 0 0.37rem 0 0.21rem;
  line-height: 0.45rem;
  font-family: PingFangSC-Regular;
  font-size: 0.24rem;
  color: #111111;
  display: inline-block;
  position: relative;
}

.status-btn:after{
  position: absolute;
  right: 0.21rem;
  top:50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  width: 0.08rem;
  height: 0.12rem;
  background: url('');
  background-size: 0.08rem 0.12rem;
}

.wx-text
{
  font-family: PingFangSC-Light;
  font-size: 0.56rem;
  color: #202021;
}

.opr-line .cus-row-col-6:nth-child(1)
{
  border-right: 1px solid #e4e4e4;
  box-sizing: border-box;
}


</style>
